import {Injectable} from '@angular/core';
import {Observable} from 'rxjs/Observable';

import {Tariff, TariffDetails} from '../entity';
import {Customer} from '../entity/customer';
import {PROFILE_TYPE} from '../../../../../common/constants';
import {HttpClient, HttpParams} from "@angular/common/http";
import {
    Availability,
    Fee,
    NewTariff
} from "../../../modules/+configuration/tariffs/entity/tariff.form-model";
import {Http} from "@angular/http";

@Injectable()
export class TariffsService {

    constructor(private _http: HttpClient, private http: Http) {
    }

    getTariffs(): Observable<Tariff[]> {
        return this._http.get<Tariff[]>('/api/backoffice/tariff');
    }

    getCustomerTariffs(): Observable<Tariff[]> {
        return this._http.get<Tariff[]>('/api/backoffice/tariff?customer');
    }

    getTariffById(id: number): Observable<TariffDetails> {
        return this._http.get<TariffDetails>(`/api/backoffice/tariff/${id}`);
    }

    getTariffsAvailableForCustomer(customer: Customer): Observable<Tariff[]> {
        let searchParams = new HttpParams();

        if(customer.type === PROFILE_TYPE.PRIVATE) {
            searchParams = searchParams.append('private', '');
        } else if (customer.type === PROFILE_TYPE.CORPORATE) {
            searchParams = searchParams.append('corporate', '');
        }

        return this._http.get<Tariff[]>('/api/backoffice/tariff', {params: searchParams});
    }

    getWhitelabelTariffs(): Observable<Tariff[]> {
        return this._http.get<Tariff[]>('/api/backoffice/tariff?whitelabel');
    }

    getBankTariffs(): Observable<Tariff[]> {
        return this._http.get<Tariff[]>('/api/backoffice/tariff?bank');
    }

    getCardTariffs(): Observable<Tariff[]> {
        return this._http.get<Tariff[]>('/api/backoffice/tariff?card');
    }

    getTariffSuggestion(clientId: number): Observable<Tariff> {
        return this._http.get<Tariff>(`/api/backoffice/tariff/suggestion?client_id=${clientId}`)
    }

    getAllAvailabilities(): Observable<Availability[]> {
        return this.http.get('/api/client/dictionary/availabilities')
        .map(response => response.json())
        .map(response => response.availabilities);
    }

    addTariff(tariff: NewTariff): Observable<any> {
        return this.http.patch(`/api/backoffice/tariff?new`, tariff)
        .map(response => response.json());
    }

    updateTariff(id: number, tariff: NewTariff): Observable<any> {
        return this.http.patch(`/api/backoffice/tariff/${id}/update`, tariff)
        .map(response => response.json());
    }

    getFees(): Observable<Fee[]> {
        return this._http.get<Fee[]>(`/api/backoffice/tariff/fees`)
    }

    canDelete(id: number): Observable<Boolean> {
        return this._http.get<Boolean>(`/api/backoffice/tariff/${id}/canDelete`)
    }

    delete(id: number): Observable<Boolean> {
        return this._http.delete<Boolean>(`/api/backoffice/tariff/${id}/delete`)
    }

    getTariffToUpdate(id: number): Observable<NewTariff> {
        return this._http.get<NewTariff>(`/api/backoffice/tariff/${id}/load/update`);
    }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/dashboard/app/shared/api/service/tariffs.service.ts